import { PurchaseStatus } from "@/api/article";
import { Badge } from "@/components/ui/badge";
import React from "react";

export const PurchaseStatusBadge = ({
  status,
  ...props
}: { status: PurchaseStatus } & React.HtmlHTMLAttributes<HTMLDivElement>) => {
  switch (status) {
    case "DELIVERED":
      return (
        <Badge {...props} variant="success">
          Commande livrée
        </Badge>
      );
    case "IN_DELIVERY":
      return (
        <Badge {...props} variant="default">
          En cours de livraison
        </Badge>
      );
    case "SHIPPED":
      return (
        <Badge {...props} variant="default">
          Commande expédiée
        </Badge>
      );
    case "PAID_FOR":
      return (
        <Badge {...props} variant="destructive">
          Commande réglée
        </Badge>
      );
    case "WAITING_PAYMENT":
      return (
        <Badge {...props} variant="warning">
          En attente de paiement
        </Badge>
      );
  }
};
